import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: easing, delay }}
    {...props}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, className = "" }) => (
  <span
    className={`font-mono text-xs uppercase tracking-[0.25em] text-[#00F0FF] ${className}`}
  >
    {children}
  </span>
);

export default Reveal;
